import { motion } from 'framer-motion'

import { ButtonRoundedSm } from '@apps-common/components/elements/button'
import { VertSpacerMd } from '@apps-common/components/layout'
import { ConfirmModal, ConfirmModalAction, ModalButton } from '@apps-common/components/modals'
import { ModalContainer } from '@apps-common/components/modals/modal'
import { OptionsModalHeader } from '@apps-common/components/modals/options-modals'
import { commonIcons } from '@apps-common/config/icons'
import { IUnitScheduledModel } from '@apps-common/types/portal/unit-scheduled'

export interface ISchedulesOptionsModal {
  schedule: IUnitScheduledModel
}

export const SchedulesOptionsModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: ISchedulesOptionsModal
}) => {
  const { schedule } = componentProps
  const { scheduledName } = schedule || {}

  return (
    <ModalContainer innerClasses='!min-w-[calc(90%-2rem)] sm:!min-w-0 !w-auto !h-auto' onDismiss={onDismiss}>
      <motion.div layout className='bg-surface-2 px-[2rem] py-[1.25rem] rounded-3xl w-full'>
        <div className='max-w-[220px] sm:w-[180px] flex flex-col mx-auto'>
          <OptionsModalHeader Icon={commonIcons.schedule} subtitle='Schedule' title={scheduledName} />
          <ButtonRoundedSm
            type='button'
            loading={false}
            icon={<commonIcons.history className='text-[1.2em]' />}
            className='w-full action-info'
            callback={() => onDismiss(JSON.stringify({ action: 'history' }), 'confirm')}
            text='History'
          />
          <div className='border-t border-border w-full mx-auto my-[20px]' />
          <ButtonRoundedSm
            type='button'
            loading={false}
            icon={<commonIcons.edit className='text-[1.2em]' />}
            className='w-full action-warning'
            callback={() => onDismiss(JSON.stringify({ action: 'edit' }), 'confirm')}
            text='Edit'
          />
          <VertSpacerMd />
          <ModalButton
            component={ConfirmModal}
            disabled={false}
            componentProps={{
              text: 'Delete',
              description: 'Confirm you would like to delete this trigger. This cannot be undone.',
              action: ConfirmModalAction.Error
            }}
            classes='w-full'
            confirmCallback={() => {
              onDismiss(JSON.stringify({ action: 'delete' }), 'confirm')
            }}
          >
            <ButtonRoundedSm
              type='button'
              loading={false}
              icon={<commonIcons.delete className='text-[1.2em]' />}
              className='w-full action-error'
              text='Delete'
            />
          </ModalButton>

          <div className='border-t border-border w-full mx-auto my-[20px]' />
          <ButtonRoundedSm
            type='button'
            loading={false}
            icon={<commonIcons.close className='text-[1.25em]' />}
            className='w-full action-neutral'
            callback={() => onDismiss(null, 'cancel')}
            text='Cancel'
          />
        </div>
      </motion.div>
    </ModalContainer>
  )
}
